import dynamic from "next/dynamic";

export const OfficeCard = dynamic(() => import("./component"));
